import type {ReactAction} from '@netx/core/bootstrap';
import {faFilePdf} from '@netx/core-icons';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {cartSavedActionCreatePDFDownload} from './cart-saved-create-pdf-download';
import {cartSavedActionCreatePDFShareLink} from './cart-saved-create-pdf-share-link';

export const cartSavedActionCreatePDFIcon = faFilePdf;

/**
 * Create pdf from saved cart assets
 * @param params
 * @returns Action
 */
export const cartSavedActionCreatePDF = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-create-pdf',
	cb: () => {}, // dispatcher.trigger(CART_SAVED_EVENT.CREATE_PDF, savedCart),
	//enableTest: () => canCreatePdfFromSavedCart(savedCart),
	icon: cartSavedActionCreatePDFIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.CREATE_PDF;
	},
	children: [
		cartSavedActionCreatePDFDownload(savedCart),
		cartSavedActionCreatePDFShareLink(savedCart),
	],
	...params,
});

export default cartSavedActionCreatePDF;
